// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nWMSS","field":"styles_field__3i_fg","fieldCol":"styles_fieldCol__QN5Ay","diffCol":"styles_diffCol__24NyU","diff":"styles_diff__1ciCm"};